export default __webpack_public_path__ + "static/media/prize-2-bm.d9701386.webp";